<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import List from '../../extend/List.vue';
import JobCardCollection from '../../components/JobCardCollection.vue';
@Component()
export default class CollectionResume extends Vue.extend(List) {
  options = {
    url: "/portal/position/favorites",
    methods: "GET"
  }
  componentName = JobCardCollection
}
</script>
